import { VEvent, VAlarm } from 'node-ical'

export function refineEvent(event: VEvent): VEvent {
  if (event.recurrences) {
    // node-ical 0.25.6+ stores recurrence exceptions with dual keys:
    // date-only key (YYYY-MM-DD) and ISO timestamp key (e.g. 2026-03-10T04:00:00.000Z).
    // Our code consistently uses YYYY-MM-DD keys for lookup and update.
    // Remove ISO timestamp keys to prevent duplicate VEVENT generation in ICSGenerator.
    for (const key of Object.keys(event.recurrences)) {
      if (key.includes('T')) {
        delete event.recurrences[key]
      }
    }

    Object.values(event.recurrences).forEach((value) => {
      refineEvent(value as VEvent)
    })
  }

  if (event.exdate) {
    // Same dual-key issue applies to exdate entries from node-ical 0.25.6+.
    // Remove ISO timestamp keys to prevent duplicate EXDATE in ICS output.
    for (const key of Object.keys(event.exdate)) {
      if (key.includes('T')) {
        delete event.exdate[key]
      }
    }
  }

  if (event.organizer && typeof event.organizer === 'string') {
    const organizer = event.organizer
    let orgEmail = null
    if (organizer.toLowerCase().startsWith('mailto:')) {
      orgEmail = organizer.substring(7)
    } else {
      orgEmail = organizer
    }
    const orgName = orgEmail.split('@')[0]
    orgEmail = 'mailto:' + orgEmail

    event.organizer = {
      val: orgEmail,
      params: {
        CN: orgName,
      },
    }
  }

  if (event.attendee && !Array.isArray(event.attendee)) {
    event.attendee = [event.attendee]
  }

  const summary: string | { val: string } = event.summary as string | { val: string }
  if (summary && typeof summary === 'object' && 'val' in summary) {
    event.summary = summary.val
  }

  const location: string | { val: string } | undefined = event.location as
    | string
    | { val: string }
    | undefined
  if (location && typeof location === 'object' && 'val' in location) {
    event.location = location.val
  }

  const description: string | { val: string } | undefined = event.description as
    | string
    | { val: string }
    | undefined
  if (description && typeof description === 'object' && 'val' in description) {
    event.description = description.val
  }

  let alarms = event.alarms || []
  Object.keys(event).forEach((key) => {
    if (key.length === 36) {
      const alarm = event[key] as VAlarm
      if (alarm.type === 'VALARM' && alarm.action === 'DISPLAY') {
        alarms.push(alarm)
      }
    }
  })
  if (alarms.length > 0) {
    event.alarms = alarms
  } else {
    event.alarms = null
  }

  return event
}
